export default "__VITE_ASSET__CyFAF5PY__"